import React, {memo, useContext} from 'react';

import {WidthItem} from 'src/components/width-item';
import {MAX_NUMBER_VALUE} from 'src/constants';

import {Dropdown} from '@pb/kit-component-dropdown';
import {Integer} from '@pb/kit-component-formatters';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {LocaleContext} from '@pb/kit-context-locale';


import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';


type Props = {
    limitId: string,
    limitDictionary: DictionaryItem,
    onClearTemporaryLimit?: (code: string) => void,
    onClearCustomLimit: (code: string) => void,

    defaultValue: number,
    customValue: number,
};

export const LicenseLimitItemLabel = memo((props: Props) => {
    const {
        limitId,
        limitDictionary,
        onClearCustomLimit,

        defaultValue,
        customValue,
    } = props;

    const {locale} = useContext(LocaleContext);

    if (customValue !== defaultValue) {
        return (
            <WidthItem width="100%">
                <Group justify="space-between">
                    <div>{limitDictionary.description}</div>
                    <Dropdown
                        placement="top-start"
                        hoverEnabled={true}
                        anchor={({anchorRef, getAnchorProps}) => (
                            <span ref={anchorRef} {...getAnchorProps()}>
                                <Group gap="xxs" alignItems="center">
                                    {customValue !== undefined ? (
                                        <Group gap="xxs">
                                            <Icon type={Icons.COGS}/>
                                            <b>custom</b>
                                        </Group>
                                    ) : null}
                                </Group>
                            </span>
                        )}>
                        <Group direction="v" gap="xs">
                            {customValue !== undefined ? (
                                <Group gap="xs" alignItems="center" justify="start">
                                    <Icon type={Icons.COGS}/>
                                    <span>Custom:</span>
                                    <b>{customValue === MAX_NUMBER_VALUE
                                        ? 'Unlimited'
                                        : Integer.format(customValue, locale)}
                                    </b>
                                    <BasicIconButton
                                        title="Clear Custom Limit"
                                        iconProps={{type: Icons.CLOSE}}
                                        onClick={() => onClearCustomLimit(limitId)}
                                    />
                                </Group>
                            ) : null}
                            <div style={{paddingLeft: 16}}>
                                <Group gap="xs" justify="start">
                                    <span>Default:</span>
                                    <b>{defaultValue === MAX_NUMBER_VALUE
                                        ? 'Unlimited'
                                        : Integer.format(defaultValue, locale)}
                                    </b>
                                </Group>
                            </div>
                        </Group>
                    </Dropdown>
                </Group>
            </WidthItem>
        );
    }

    return <span>{limitDictionary.description}</span>;
});
